import {
    GetChannelQuery_channel_hls,
    GetChannelQuery_channel_metadata,
} from "../Channels/Overview/__generated__/GetChannelQuery";

export interface ChannelCustomization {
    targetLatency: number;
    hls: { enabled: boolean };
}

export type ProperyChangeType = "main" | "latency";

interface UpdateChannelCustomization {
    customization: ChannelCustomization;
    type: ProperyChangeType;
    key: string;
    value: string | boolean | number | object;
}

export function getInitialCustomization(
    metadata: GetChannelQuery_channel_metadata,
    hls: GetChannelQuery_channel_hls,
): ChannelCustomization {
    return {
        targetLatency: metadata?.customization?.targetLatency ?? 0,
        hls: {
            enabled: hls.enabled,
        },
    };
}

export function updateCustomization({
    customization,
    type,
    key,
    value,
}: UpdateChannelCustomization): ChannelCustomization {
    switch (type) {
        case "latency":
        case "main":
            return updateSetting(customization, key, value);
    }
    // check for type in later stage
}

function updateSetting(
    customization: ChannelCustomization,
    key: string,
    value: string | boolean | number | object,
): ChannelCustomization {
    return {
        ...customization,
        [key]: value,
    };
}
